<template>
  <page :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ getIntermediaryName }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action v-if="item.name === 'interCommDiscFactorsQuery'">
                    <v-icon :class="isMatchRoute('queryInterCommDiscFactors') ? 'primary--text':''">{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-else>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content v-if="item.name === 'interCommDiscFactorsQuery'">
                    <v-list-tile-title :class="isMatchRoute('queryInterCommDiscFactors') ? 'primary--text':''">{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      sideMenu: [
        { name: 'queryProfile', text: 'Profile', icon: 'mdi-account' },
        { name: 'queryUsers', text: 'Users', icon: 'mdi-folder-account' },
        { name: 'queryProducts', text: 'Products', icon: 'mdi-cube-outline' },
        { name: 'interCommDiscFactorsQuery', text: 'Commission/Discount', icon: 'mdi-sale' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    getIntermediaryName() {
      return this.$store.state.adminInter.intermediary.intermediaryName
    }
  },
  methods: {
    ...mapActions([
      'interMenuInit'
    ]),
    async doInit() {
      await this.interMenuInit(this.inter)
    }
  },
  props: ['inter'],
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
.queryPnl {
  margin-top: 50px;
}
</style>
